"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = props => _react.default.createElement(_SvgIcon.default, props, _react.default.createElement("path", {
  d: "M11.9786 0C15.3353 0 18.1778 1.16438 20.5069 3.49313C22.8349 5.80763 24 8.643 24 12C24 15.3578 22.8566 18.1714 20.5706 20.4427C18.1567 22.8142 15.2921 24 11.9786 24C8.73525 24 5.92125 22.8214 3.53587 20.4637C1.179 18.1072 0 15.2865 0 12.0004C0 8.72925 1.179 5.8935 3.53587 3.4935C5.86425 1.16438 8.67863 0 11.9786 0ZM12.0214 2.1645C9.29287 2.1645 6.98588 3.129 5.1 5.05763C3.1425 7.04363 2.16412 9.35775 2.16412 12C2.16412 14.6719 3.13538 16.9714 5.07788 18.9C7.02075 20.8433 9.33488 21.8141 12.0206 21.8141C14.6918 21.8141 17.0209 20.8361 19.0065 18.8786C20.8924 17.0501 21.8351 14.7578 21.8351 12C21.8351 9.25762 20.8777 6.94313 18.9641 5.05763C17.064 3.12825 14.7495 2.1645 12.0214 2.1645ZM16.5431 9.171V11.2282H7.82175V9.171H16.5431ZM16.5431 13.0286V15.0848H7.82175V13.0286H16.5431Z",
  fill: "black"
}));

exports.default = _default;
module.exports = exports.default;